<template>
    <div class="bg-transparent h-10 w-full flex items-center p-1 chatinputbox relative">
        <input v-model="message" ref="inputBox" @keyup.enter="submit" :disabled="disabled" type=text class="disabled:opacity-75 w-full bg-white dark:bg-lobby-bg border border-gray-400 dark:border-outter-border text-black dark:text-white outline-none rounded py-1 pl-2 pr-10 text-sm" :placeholder="placeholder">
        <div @click="submit"
            class="absolute right-0 top-1 bottom-1 flex items-center justify-center w-10"
            :class="message.length && !sending ? 'text-black dark:text-gray-200' : 'text-gray-300 dark:text-gray-700'"
        >
            <i class="fa-light fa-paper-plane-top text-lg"></i>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ChatInputBox',
    props: ['token', 'connected', 'account'],
    data() {
        return {
            message: '',
            sending: false
        }
    },
    computed: {
        placeholder() {
            return this.connected && this.account ? 'Type here...' : 'Sign in to enable chat'
        },
        disabled() {
            return !this.connected || !this.account || this.sending
        }
    },
    methods: {
        focus() {
            if (!this.disabled) {
                this.$nextTick(() => this.$refs.inputBox.focus())
            }
        },
        submit() {
            if (!this.message.length || this.sending) {
                return
            }
            this.sending = true
            window.axios.post('/api/message', {
                'message': this.message
            }, {
                headers: {
                    'Authorization': `Bearer ${this.token}`
                }
            }).catch((err) => {
                if (err.response && err.response.status == 401) {
                    this.$toast.error('You need to login.')
                } else {
                    this.$toast.error(err.message)
                }
            }).then(() => {
                this.message = ''
                this.sending = false
                this.focus()
            })
        }
    }
}
</script>
